import { useGeolocation } from './geolocation'
import { useLocationMarker } from './location-marker'
import { eventManager } from '../event-manager'
import { mapManager } from '../map-manager'

const locationButton = `
  <button style="
    margin: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    border: 1px solid rgb(68, 68, 68);
    background-color: white;
    cursor: pointer;
  ">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM11.25 18.4572C8.2595 18.1136 5.88638 15.7405 5.5428 12.75H9V11.25H5.5428C5.88638 8.2595 8.2595 5.88638 11.25 5.5428V9H12.75V5.5428C15.7405 5.88638 18.1136 8.2595 18.4572 11.25H15V12.75H18.4572C18.1136 15.7405 15.7405 18.1136 12.75 18.4572L12.75 15H11.25L11.25 18.4572Z" fill="rgb(90,90,90)"/>
    </svg>
  </button>`

type Props = {
  minZoomLevel: number
}

export const useUserLocationButton = ({ minZoomLevel }: Props) => {
  const { updateLocationMarker, removeLocationMarker } = useLocationMarker()

  const { getGeolocationPosition } = useGeolocation()

  const updateMap = (latLng: naver.maps.LatLng) => {
    mapManager.withMap(map => {
      const currentZoomLevel = map?.getZoom() ?? 0

      const targetZoomLevel =
        currentZoomLevel < minZoomLevel ? minZoomLevel : currentZoomLevel

      map?.morph(latLng, targetZoomLevel, {
        duration: 100,
        easing: 'easeOutCubic',
      })

      // 지도 이동 후 업데이트
      setTimeout(() => {
        eventManager.triggerEvent('update')
      }, 100)
    })
  }

  const moveToCurrentLocation = async () => {
    const latLng = await getGeolocationPosition()

    if (latLng) {
      updateLocationMarker(latLng)
      updateMap(latLng)
    } else {
      removeLocationMarker()
    }
  }

  const createUserLocationButton = () => {
    mapManager.withMap(map => {
      const POSITION = naver.maps.Position

      const customControl = new naver.maps.CustomControl(locationButton, {
        position: POSITION.RIGHT_TOP,
      })

      customControl.setMap(map)

      naver.maps.Event.addDOMListener(
        customControl.getElement(),
        'click',
        moveToCurrentLocation,
      )
    })
  }

  return { createUserLocationButton }
}
